import { ErrorResponse, GlobalResponseObject, MessageRequest } from "@gtpl/shared-models/common-models";
import { CommonResponse, DeviceCategoryAndDeptNameRequest, DeviceCategoryEnum } from "@gtpl/shared-models/masters";
import { DayWiseDeptTempResponse, DayWiseTemperatureModel, DeptTemperaturesResponse, DeviceDetailsResponse, TemperatureLogResponse, TemperatureResponse, TemperatureResponseModel, TemperaturesModel, UidResponseModel } from "@gtpl/shared-models/warehouse-management";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { ForkLiftJobService } from "@gtpl/shared-services/warehouse-management";
import { NoRecordsFound } from "@gtpl/shared-utils/error-messages";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import appSettings from "apps/services/config";
import { getManager } from "typeorm";
import { tempLogReq } from "./dto/temp-log-data.req";
import { Temperatures } from "./dto/temp-log.model";
import { TemperatureLogDto } from "./dto/temperature-log.dto";
import { TemperatureLog } from "./entity/temperature-log.entity";
import { TemperatureLogRepository } from "./repository/temperature-log.repository";
import { DateDeptRequest, DayWiseTempRequest, DeptDateHourRequest, UidRequest } from "./request/date-dept.request";
import { TemperatureLogAdapter } from "./temperature-log.adapter";
import { DeviceRequest } from "../fork-lift-jobs/dto/device.request";
import axios from "axios";
import { DeviceCodeAndInfoRequest } from "./dto/deivce-id.request";
import { TemperatureExtResponse, TemperatureExtResponseModel } from "./dto/temperature-ext-response/temperature-ext.response";
import wmsConfigs from "apps/services/warehouse-service/config";
import { DeviceService, UnitcodeService } from "@gtpl/shared-services/masters";
import { Cron } from "@nestjs/schedule";
import { DeviceReq } from "./dto/device-req";
import moment from "moment";

@Injectable()
export class TemperatureLogService {
  constructor(
    private tempRepository: TemperatureLogRepository,
    private tempAdapter: TemperatureLogAdapter,
    private wpService: WhatsAppNotificationService,
    private forkLiftJobService: ForkLiftJobService,
    private deviceService: DeviceService,
    private unitService: UnitcodeService
  ) { }

  async createTemperatureLog(tempDto: TemperatureLogDto, isUpdate: boolean, request: Request): Promise<CommonResponse> {
    console.log(tempDto)
    const convertedTempEntity: TemperatureLog = this.tempAdapter.convertDtoToEntity(tempDto, isUpdate);
    const savedTempEntity: TemperatureLog = await this.tempRepository.save(convertedTempEntity);
    const savedtempDto: TemperatureLogDto = this.tempAdapter.convertEntityToDto(savedTempEntity);
    const req = new DeviceRequest()
    req.ip = '192.168.2.91';
    req.deviceName = 'lights';
    req.bulbId = 2
    req.on = true;
    req.hue = 22500;
    req.userName = 'FzHzpbLABOtcs2MBwlW6L7q30DDgqsT-O2uykUbS'
    if (tempDto.temperature > -16 || tempDto.temperature < -20) {
      req.on = true;
      req.hue = 169;
    }
    var lightAlert = await this.forkLiftJobService.getOperateDevice(req);
    console.log(lightAlert, 'light alert')

    if (tempDto.temperature > -16 || tempDto.temperature < -20) {
      const messageReq = new MessageRequest('917036784473', 'WareHouse Temperature Alert', (String(tempDto.temperature) + '° C'), ' Schemax')
      var messageStatus = await this.wpService.sendPersonalMessage(messageReq);
      // if (messageStatus.status) {
      //   return new CommonResponse(true, 11108, "Message Sent Successfully", messageStatus)
      // }
    }
    if (savedtempDto) {
      const response = new CommonResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'temp date Updated Successfully' : 'temp Created Successfully', savedtempDto);
      return response;
    } else {
      throw new TemperatureLogResponse(false, 11106, 'temp saved but issue while transforming into DTO');
    }


  }


  async getTemperatures(tempReq: DateDeptRequest): Promise<TemperatureResponse> {
    const date = tempReq.date;
    const deptName = tempReq.deptName;
    const tempResponseMap = new Map<string, Map<string, TemperaturesModel[]>>();
    const records = await this.tempRepository.getTemperaturesLogByDate(date, deptName);
    if (records.length == 0) {
      throw new ErrorResponse(0, 'No data found');
    }
    for (const record of records) {
      if (!tempResponseMap.has(record.date)) {
        tempResponseMap.set(record.date, new Map<string, TemperaturesModel[]>());
      }
      if (!tempResponseMap.get(record.date).has(record.dept_name)) {
        tempResponseMap.get(record.date).set(record.dept_name, []);
      }
      tempResponseMap.get(record.date).get(record.dept_name).push(new TemperaturesModel(record.hour, record.minutes, record.uom));
    }
    const tempModelArray: TemperatureResponseModel[] = [];
    tempResponseMap.forEach((tempModel, date) => {
      tempModel.forEach((tempArrays, dept) => {
        tempModelArray.push(new TemperatureResponseModel(date, deptName, null, null, tempArrays));
      });
    });
    return new TemperatureResponse(true, 0, 'Retrived successfully', tempModelArray);
  }

  async getCurrentTemperature(deptDateHourReq: DeptDateHourRequest): Promise<DeptTemperaturesResponse> {
    const date = deptDateHourReq.date
    const hour = deptDateHourReq.hour
    const minutes = deptDateHourReq.minutes
    const deptCode = deptDateHourReq.deptCode
    const uid = deptDateHourReq.uid
    const tempHourResponseMap = new Map<number, TemperaturesModel[]>();
    const tempModelArray: TemperaturesModel[] = [];
    const records = await this.tempRepository.getTempHour(date, hour, deptCode, uid, minutes)
    if (records.length == 0) {
      return new DeptTemperaturesResponse(false, 0, 'No data found. ',);
    }
    for (const record of records) {
      if (!tempHourResponseMap.has(record.hour)) {
        tempHourResponseMap.set(record.hour, []);
      }
      tempHourResponseMap.get(record.hour).push(new TemperaturesModel(record.hour, record.temperature, record.uom));
      tempModelArray.push(new TemperaturesModel(record.hour, record.temperature, record.uom))
    }
    return new DeptTemperaturesResponse(true, 0, 'retrived succesfully', tempModelArray);
  }

  async getTempDeviceDetails(req: UidRequest): Promise<DeviceDetailsResponse> {
    const uid = req.uid
    const responseMap = new Map<String, UidResponseModel[]>();
    const array: UidResponseModel[] = [];
    const records = await this.tempRepository.getUidDetails(uid)
    if (records.length == 0) {
      throw new ErrorResponse(0, 'No data found');
    }
    for (const record of records) {
      if (!responseMap.has(record.date)) {
        responseMap.set(record.date, []);
      }
      responseMap.get(record.date).push(new UidResponseModel(record.temperature, record.load_status, record.date, record.uid));
      array.push(new UidResponseModel(record.temperature, record.load_status, record.date, record.uid))
    }
    return new DeviceDetailsResponse(true, 0, 'retrived succesfully', array);
  }

  async getAllTempDetails(): Promise<CommonResponse> {
    const manager = getManager()
    const query = `SELECT tl.temperature as temperature , tl.dept_name as deptName , tl.module as module, uc.unit_name as plant, tl.date as tempDate FROM ` + appSettings.warehouse_db + `.temperature_log tl 
    LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = tl.unit_id `
    const data = await manager.query(query)
    if (data.length > 0) {
      const response = new CommonResponse(true, 1111, 'Data retrived successfully', data);
      return response;
    }
    else {
      return new CommonResponse(false, 1010, 'Data not found');
    }
  }


  async getDayWiseTemeperaturesForDept(dayWiseReq: DayWiseTempRequest): Promise<DayWiseDeptTempResponse> {
    const deptCode = dayWiseReq.deptCode
    const month = dayWiseReq.month
    const startDate = dayWiseReq.startDate
    const endDate = dayWiseReq.endDate
    const uid = dayWiseReq.uid
    const dayTempResponseMap = new Map<string, DayWiseTemperatureModel[]>();
    const dayTempModelArray: DayWiseTemperatureModel[] = [];
    const records = await this.tempRepository.getDayWiseTempByDept(deptCode, month, startDate, endDate, uid)
    if (records.length == 0) {
      throw new ErrorResponse(0, 'No data found');
    }
    for (const record of records) {
      if (!dayTempResponseMap.has(record.date)) {
        dayTempResponseMap.set(record.date, []);
      }
      dayTempResponseMap.get(record.date).push(new DayWiseTemperatureModel(record.date, record.dept_name, record.highest_temperature, record.lowest_temperature));
      dayTempModelArray.push(new DayWiseTemperatureModel(record.date, record.dept_name, record.highest_temperature, record.lowest_temperature))
    }
    return new DayWiseDeptTempResponse(true, 0, 'retrived succesfully', dayTempModelArray);
  }

  async getCountOfTemperature(): Promise<CommonResponse> {
    try {
      const manager = getManager()
      let query = `SELECT COUNT(temp_log_id) as countOfTemp FROM temperature_log WHERE temperature > '-18' `
      let queryResult = await manager.query(query)
      if (queryResult) {
        return new CommonResponse(true, 1001, "retrived successfully", queryResult);
      }
      else {
        return new CommonResponse(false, 1010, "no data found");
      }
    } catch (error) {
      // console.log(error);
      return error
    }
  }

  async tempDataDump(tempDto: TemperatureLogDto, req: tempLogReq): Promise<CommonResponse> {
    const manager = getManager();
    try {
      const tempData = await this.forkLiftJobService.getTempLogData(req);
      console.log(tempData.result)
      let setFlag = new Set<boolean>();
      for (const tempDataItem of tempData.result) {
        const date = tempDataItem.timestamp;
        console.log(date);
        const year = new Date(date).getFullYear()
        const day = new Date(date).getDay()
        const month = new Date(date).getMonth()
        const hrs = new Date(date).getHours()
        const minutes = new Date(date).getMinutes()
        const temp = tempDataItem.current_temp ? tempDataItem.current_temp : 0
        // console.log(date.getMonth());
        // let CurrentYear = today.getFullYear();
        // let CurrentMonth = today.getMonth();

        const insertDataQry = `INSERT INTO ` + appSettings.warehouse_db + `. temperature_log(load_status,uid,date,temperature,dept_name,dept_code,month,hour,minutes,unit_id,day,uom) values('${tempDataItem.load_status}','${tempDataItem.uid}','${tempDataItem.timestamp}','${temp}','warehouse','W5636',${month},${hrs},${minutes},2,${day},0)`
        const insertData = await manager.query(insertDataQry)
        console.log(insertData)
        if (insertData) {
          setFlag.add(true)
        } else {
          setFlag.add(false)
          break;
        }
      }
      const reqD = new DeviceRequest()
      reqD.ip = '192.168.0.166';
      reqD.deviceName = 'lights';
      reqD.bulbId = 2
      reqD.on = true;
      reqD.hue = 22500;
      reqD.userName = 'FzHzpbLABOtcs2MBwlW6L7q30DDgqsT-O2uykUbS'
      if (tempDto.temperature > -16 || tempDto.temperature < -20) {
        reqD.on = true;
        reqD.hue = 169;
      }
      if (setFlag) {
        return new CommonResponse(true, 2222, 'data inserted')
      } else {
        await manager.release()
        return new CommonResponse(false, 2222, 'something went wrong')
      }
    } catch (err) {
      await manager.release()
      return new CommonResponse(false, 2222, err)
    }
  }

  /**
   * triggers the job for every unit - currently configured for every 5 mins
   * @returns 
   */
  @Cron(`0 */${wmsConfigs.externalApis.pixel.integrationApiIntervalMinutes} * * * *`)
  async triggerTemperatureCapturing(): Promise<GlobalResponseObject> {
    const units = await this.unitService.getAllActiveUnitcode();
    const unitsData = units.data;
    if (unitsData.length == 0) {
      throw new ErrorResponse(0, 'No plants found to run the temperature download job');
    }
    for (const unit of unitsData) {
      if (unit.isActive == false) {
        continue
      }
      // console.log('going to be called ' + unit.unitcodeId);
      const req = new DeviceCategoryAndDeptNameRequest('Warehouse', DeviceCategoryEnum.TEMPERATURE, unit.unitcodeId);
      // do not wait for the response
      this.getTemperatureDevicesAndLogTemperatures(req);
    }
    return new GlobalResponseObject(true, 0, 'Device capturing started successfully');
  }

  /**
   * gets the temperature devices for the given unit and department and device category and downloads all the temperatures
   * @param req 
   */
  async getTemperatureDevicesAndLogTemperatures(req: DeviceCategoryAndDeptNameRequest): Promise<GlobalResponseObject> {
    try {
      // currently get all the devices whose category is temperature of warehouse department
      const temperatureDevices = await this.deviceService.getAllDevicesByDeviceCategoryAndDepartment(req);
      const deviceCodeAndInfoReqs: DeviceCodeAndInfoRequest[] = [];
      if (temperatureDevices.data) {
        temperatureDevices.data.forEach(rec => {
          const deviceReq = new DeviceCodeAndInfoRequest();
          deviceReq.apiKey = rec.secretKey;
          deviceReq.deptCode = rec.deptCode;
          deviceReq.deptName = rec.deptName;
          deviceReq.deviceCode = rec.deviceName;
          deviceReq.deviceName = rec.deviceName;
          deviceReq.deviceUid = rec.deviceMacId;
          deviceReq.module = rec.module;
          deviceReq.subModule = '';
          deviceReq.unit = rec.plantId;
          deviceCodeAndInfoReqs.push(deviceReq);
        });
      }
      if (deviceCodeAndInfoReqs.length > 0) {
        await this.fetchTemperatureFromExtDeviceAndLogRecords(deviceCodeAndInfoReqs);
      }
      return new GlobalResponseObject(true, 0, 'Device capturing done successfully');
    } catch (error) {
      // console.log(error);
      throw error;
    }
  }

  /**
   * 
   * @param uid 
   * @param satrtTimeStamp 
   * @param endTimeStamp 
   * @param apiKey 
   */
  getApiUrl(uid: string, startTimeStamp: number, endTimeStamp: number, apiKey: string): string {
    const baseUrl = wmsConfigs.externalApis.pixel.temperatureRetrievalApi;
    return `${baseUrl}?uid=${uid}&startTime=${startTimeStamp}&endTime=${endTimeStamp}&apikey=${apiKey}`;
  }


  /**
   * gets the temperatures from the ext devices and persist them in the tables
   * @param temperatureDevicesInfo 
   * @returns 
   */
  async fetchTemperatureFromExtDeviceAndLogRecords(temperatureDevicesInfo: DeviceCodeAndInfoRequest[]): Promise<GlobalResponseObject> {
    const date = new Date();
    const toTimeStamp = Math.ceil(Date.now() / 1000);
    const fromTimeStamp = Math.floor(date.setMinutes(date.getMinutes() - 30) / 1000);
    const tempEntities: TemperatureLog[] = [];
    console.log(temperatureDevicesInfo);
    for (const device of temperatureDevicesInfo) {
      const deptCode = device.deptCode;
      const deptName = device.deptName;
      const unit = device.unit;
      const module = device.module;
      const subModule = device.subModule;
      const apiUrl = this.getApiUrl(device.deviceUid, fromTimeStamp, toTimeStamp, device.apiKey);
      console.log(apiUrl);
      const apiRes = await axios.get(apiUrl);
      const response: TemperatureExtResponse = apiRes.data;
      // console.log(response);

      // an array of time intervals at which the captured temperatures are stored on to the logs
      const temps: TemperatureExtResponseModel[] = response.data;
      for (const timeIntervalTemp of temps) {
        const lastCapturedTimeStamp = timeIntervalTemp.timestamp; // unix time stamp
        const temperatureArray = timeIntervalTemp.temperature;
        const collectedAtEvery = timeIntervalTemp.interval.collection; // minutes
        const transmittedAtEvery = timeIntervalTemp.interval.transmit;
        let noOfTimesToBeCollected = transmittedAtEvery / collectedAtEvery; // the count of total temperature stamps within one transmit
        let noOfTimesReallyCollected = temperatureArray.length;
        // usually this should be equal to the size of the temperature array
        // const currCapturingStartedAt = this.subtractMinutesFromRefTime(lastCapturedTimeStamp, collectedAtEvery*noOfTimesToBeCollected);
        let counter = 0;
        while (noOfTimesReallyCollected > 0) {
          const temperature = temperatureArray[noOfTimesReallyCollected - 1];
          // multiplying the timestamp value by 1000 as its a unix timestamp
          const collectedTime = this.subtractMinutesFromRefTime(collectedAtEvery * counter, lastCapturedTimeStamp * 1000);
          noOfTimesReallyCollected--;
          // console.log('collected at : ' + collectedTime + ' -- ' + temperature);
          counter++;
          const hour = collectedTime.getHours();
          const minute = collectedTime.getMinutes();
          const day = collectedTime.getDay();
          const month = collectedTime.getMonth();
          // check if this record already recorded in the DB for the given device, dat, hour and minutes
          const checkIfRecordExist = await this.tempRepository.findOne({
            select: ['tempLogId'], where: {
              day: day, hour: hour, minutes: minute, uid: device.deviceUid,
            }
          });
          if (!checkIfRecordExist) {
            const tempEntity = new TemperatureLog();
            tempEntity.createdUser = 'SYSTEM';
            tempEntity.day = day;
            tempEntity.deptCode = deptCode;
            tempEntity.deptName = deptName;
            tempEntity.hour = hour;
            tempEntity.minutes = minute;
            tempEntity.module = module;
            tempEntity.month = month;
            tempEntity.subModule = subModule;
            tempEntity.temperature = temperature;
            tempEntity.uid = device.deviceUid; // the device uid 
            tempEntity.unitId = unit;
            tempEntity.uom = 'F';
            const date = new Date();
            date.setHours(hour); date.setMinutes(minute); date.setDate(day); date.setMonth(month);
            tempEntity.date = date;
            tempEntities.push(tempEntity)
          }
        }
      }
    }
    // bulk save the records
    await this.tempRepository.save(tempEntities, { reload: false });
    return new GlobalResponseObject(true, 0, 'Records saved successfully');
  }

  /**
   * subtracts given minutes from a given timestamp and returns the modified timestamp
   * @param numOfMinutes 
   * @param refTimeStamp 
   * @returns 
   */
  subtractMinutesFromRefTime(numOfMinutes: number, refTimeStamp: number) {
    const date = new Date(refTimeStamp);
    date.setMinutes(date.getMinutes() - numOfMinutes);
    return date;
  }

  async getAndInsertTempData(req: DeviceReq): Promise<CommonResponse> {
    const manager = getManager();
    try {
      if(!req.event_type) return new CommonResponse(false,200,"Event type not found ")
      if (req.event_type.includes("buttonPress")) {
        const tempData = await this.deviceService.getDeviceDataByMacId({ deviceMacId: req.deviceUid })
        const date = moment.unix(req.timestamp)
        const isoDate = date.toISOString();
        console.log(date,'date')
        const day = moment(date).date()
        const month = (moment(date).month() + 1)
        const hrs = moment(date).hours()
        const minutes = moment(date).minutes()
        const tempLogData = new TemperatureLogDto(undefined, '', req.deviceUid, tempData.data[0].deptName, tempData.data[0].deptCode, tempData.data[0].plantId, tempData.data[0].module, '', isoDate, day, month, hrs, minutes, Number(req.temperature[0]), 'F', undefined, 'admin', undefined, 'admin', undefined)
        const insertData = await this.tempRepository.save(tempLogData)
        if (insertData)  return new CommonResponse(true, 201, 'Data inserted sucessfully')
        await manager.release()
        return new CommonResponse(false, 200, 'Something went wrong,data not inserted')
      }else{
        return new CommonResponse(false, 200, 'Not a "buttonPress" event')
      }
    } catch (err) {
      await manager.release()
      return new CommonResponse(false, 2222, err)
    }
  }



}

